<div class="likert-wrapper">
  <div *ngIf="minLabelText && maxLabelText" class="likert-labels">
    <span>{{minLabelText}}</span>
    <span>{{maxLabelText}}</span>
  </div>
  <div class="likert-row">
    <div *ngFor="let val of values" class="likert-cell {{activeColor(val)}}" [ngClass]="{'active' : value===val}"
      (click)="onStepClick(val)">
      <span>{{val}}</span>
    </div>
  </div>
</div>